import { createContext } from "react";

const ThemeContext = createContext({darkTheme: false, str: "" })

export default ThemeContext;